// extracted by mini-css-extract-plugin
export default {"action":"styles_action__p7CXo","add":"styles_add__L7N-D"};